import { wrapRetry } from '@perpay-web/utils/importUtils';

export const importCreditScoresContainer = () =>
    wrapRetry(
        () =>
            import(
                /* webpackChunkName: "CreditScoresContainer" */
                '@perpay-web/fintech/components/containers/CreditScoresContainer'
            ),
    );
